import type { IntlShape } from "react-intl";
import { CommunicationLanguage } from "@/graphql/generated/operations";

// The language of a mail to one recipient, which genesis resolves on the server
// (@external-adr GENESIS-0097-a-mail-is-written-in-the-language-resolved-for-its-recipient). Not the
// interface language of this browser (ui-store): that one never decides how a mail is written.

/** Option labels for a language choice: endonyms, the same in every interface language, as in LanguageControl. */
export const COMMUNICATION_LANGUAGE_OPTIONS: ReadonlyArray<{ value: CommunicationLanguage; label: string }> = [
  { value: CommunicationLanguage.De, label: "Deutsch" },
  { value: CommunicationLanguage.En, label: "English" },
];

/** The language's name in the reader's interface language, for running text ("wird auf Englisch gesendet"). */
export function communicationLanguageName(intl: IntlShape, language: CommunicationLanguage): string {
  return language === CommunicationLanguage.De
    ? intl.formatMessage({ id: "communicationLanguage.de", defaultMessage: "German" })
    : intl.formatMessage({ id: "communicationLanguage.en", defaultMessage: "English" });
}
